import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTooltip, NgbModal, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-compensatory-off-policy-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip, LoaderComponent, NgbTimepickerModule],
  templateUrl: './compensatory-off-policy-form.component.html',
  styleUrl: './compensatory-off-policy-form.component.scss'
})
export class CompensatoryOffPolicyFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  Applicabilitys = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;

  CompensatoryOff = {
    SelectType: 'insert',
    ESS_CompOffRuleId: 0,
    CompOffRuleName: null,
    CompOffRaiseFor: 'FD', //'FD/HD'//no need to show as always FD -- sakshi
    ReasonMandatory: false,
    IsCompOffOnAllDay: false,
    IsCompOffOnRegularDay: false,
    IsCompOffOnHoliday: true,
    IsCompOffOnWeekOff: true,
    // CreditLeaveExpire: 0 as any,
    DefaultRule: false,
    EmpType: 'FRONT',
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    IsSunday: false,
    IsMonday: false,
    IsTuesday: false,
    IsWednesday: false,
    IsThursday: false,
    IsFriday: false,
    IsSaturday: false,
    CompOffFullDayHr: null as any,
    CompOffFullDayHrObj: null as any,
    CompOffHalfDayHr: null as any,
    CompOffHalfDayHrObj: null as any,
    ValidateShiftForFullDay: false,
    ValidateShiftForHalfDay: false,
    AllowRequestAfterMonthlock: false,
    IsCreditLeaveBefore: false,
    CreditLeaveBefore: 0,
    IsCreditLeaveAfter: false,
    CreditLeaveAfter: 0
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private approvalMatrix: ApprovalMatrixService,
    private combo: ComboService,
    private modalService: NgbModal,
    private compensatoryOff: CompensatoryOffService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.CompensatoryOff.ESS_CompOffRuleId = parseInt(params['id']));
  }

  ngOnInit(): void {
    if (this.CompensatoryOff.ESS_CompOffRuleId > 0) {
      this.ESS_CompOffRuleLoad();
    } else {
      this.GetApplicability();
    }
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_CompOffRuleInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.CompensatoryOff.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.CompensatoryOff.WebESSApplicabilityId).length == 0) {
          this.CompensatoryOff.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.CompensatoryOff.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.CompensatoryOff.MappedId = null;
        this.LastWebESSApplicabilityId = this.CompensatoryOff.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.CompensatoryOff.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.CompensatoryOff.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.CompensatoryOff.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.CompensatoryOff.WebESSApplicabilityId == 3 || this.CompensatoryOff.WebESSApplicabilityId == 4 || this.CompensatoryOff.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                  IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                  IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: this.CompensatoryOff.MappedId != null ? this.CompensatoryOff.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.CompensatoryOff.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.CompensatoryOff.WebESSApplicabilityId == 3 ? 'Client' : this.CompensatoryOff.WebESSApplicabilityId == 4 ? 'Site' : this.CompensatoryOff.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.CompensatoryOff.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.CompensatoryOff.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.CompensatoryOff.WebESSApplicabilityId == 3 || this.CompensatoryOff.WebESSApplicabilityId == 4 || this.CompensatoryOff.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.CompensatoryOff.WebESSApplicabilityId == 4 || this.CompensatoryOff.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.CompensatoryOff.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.CompensatoryOff.WebESSApplicabilityId == 8 || this.CompensatoryOff.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.CompensatoryOff.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.CompensatoryOff.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.CompensatoryOff.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_CompOffRuleInsertUpdate() {
    await this.common.getPageRights();
    this.CompensatoryOff.CreditLeaveBefore = this.CompensatoryOff.IsCreditLeaveBefore ? this.CompensatoryOff.CreditLeaveBefore : 0;
    this.CompensatoryOff.CreditLeaveAfter = this.CompensatoryOff.IsCreditLeaveAfter ? this.CompensatoryOff.CreditLeaveAfter : 0;
    this.SearchDropdown('', 'Applicability');
    if (this.CompensatoryOff.CompOffFullDayHrObj != null) {
      // this.CompensatoryOff.CompOffFullDayHr = this.CompensatoryOff.CompOffFullDayHrObj.hour + ':' + this.CompensatoryOff.CompOffFullDayHrObj.minute;
      const hour1 = String(this.CompensatoryOff.CompOffFullDayHrObj.hour).padStart(2, '0');
      const minute1 = String(this.CompensatoryOff.CompOffFullDayHrObj.minute).padStart(2, '0');
      this.CompensatoryOff.CompOffFullDayHr = hour1 + ':' + minute1;
    }
    if (this.CompensatoryOff.CompOffHalfDayHrObj != null) {
      //this.CompensatoryOff.CompOffHalfDayHr = this.CompensatoryOff.CompOffHalfDayHrObj.hour + ':' + this.CompensatoryOff.CompOffHalfDayHrObj.minute;
      const hour = String(this.CompensatoryOff.CompOffHalfDayHrObj.hour).padStart(2, '0');
      const minute = String(this.CompensatoryOff.CompOffHalfDayHrObj.minute).padStart(2, '0');
      this.CompensatoryOff.CompOffHalfDayHr = hour + ':' + minute;
    }
    // if (!this.CompensatoryOff.IsCompOffOnRegularDay && !this.CompensatoryOff.IsCompOffOnHoliday && !this.CompensatoryOff.IsCompOffOnWeekOff) {
    //   this.toast.show({ message: 'Please select compensatory off can be raised only on', type: toastTypeEnum.warning });
    // } else
    if (this.CompensatoryOff.EmpType != 'FRONT' && this.CompensatoryOff.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.CompensatoryOff.WebESSApplicabilityId == null) {
      this.toast.show({ message: "Please select applicability", type: toastTypeEnum.warning });
    } else if (this.CompensatoryOff.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: "Please select sub applicability", type: toastTypeEnum.warning });
    } else if (this.CompensatoryOff.WebESSApplicabilityId == 0 && this.CompensatoryOff.DefaultRule) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.CompensatoryOff.ESS_CompOffRuleId == 0) || (this.common.PageRight.IsEdit && this.CompensatoryOff.ESS_CompOffRuleId > 0)) {
          if (result) {
            this.isDisabled = true;
            // if (this.CompensatoryOff.CreditLeaveExpire == '' || this.CompensatoryOff.CreditLeaveExpire == null) {
            //   this.CompensatoryOff.CreditLeaveExpire = 0;
            // }
            this.CompensatoryOff.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.CompensatoryOff.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.compensatoryOff.ESS_CompOffRuleInsertUpdate(this.CompensatoryOff).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  ESS_CompOffRuleLoad() {
    this.isDisabled = true;
    this.compensatoryOff.ESS_CompOffRuleLoad({ SelectType: 1, ESS_CompOffRuleID: this.CompensatoryOff.ESS_CompOffRuleId }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.CompensatoryOff = response.Table[0];
        this.CompensatoryOff.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.CompensatoryOff.SelectType = 'update';
        if (this.CompensatoryOff.CompOffFullDayHr != null && this.CompensatoryOff.CompOffFullDayHr != "") {
          this.CompensatoryOff.CompOffFullDayHrObj = { hour: parseInt(this.CompensatoryOff.CompOffFullDayHr.split(':')[0]), minute: parseInt(this.CompensatoryOff.CompOffFullDayHr.split(':')[1]) };
        }

        if (this.CompensatoryOff.CompOffHalfDayHr != null && this.CompensatoryOff.CompOffHalfDayHr != "") {
          this.CompensatoryOff.CompOffHalfDayHrObj = { hour: parseInt(this.CompensatoryOff.CompOffHalfDayHr.split(':')[0]), minute: parseInt(this.CompensatoryOff.CompOffHalfDayHr.split(':')[1]) };
        }
        this.LastWebESSApplicabilityId = this.CompensatoryOff.WebESSApplicabilityId;
        if (this.CompensatoryOff.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 8) {
          // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.CompensatoryOff.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.CompensatoryOff.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.CompensatoryOff.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckAll() {
    this.CompensatoryOff.IsCompOffOnRegularDay = this.CompensatoryOff.IsCompOffOnAllDay;
    this.CompensatoryOff.IsCompOffOnHoliday = this.CompensatoryOff.IsCompOffOnAllDay;
    this.CompensatoryOff.IsCompOffOnWeekOff = this.CompensatoryOff.IsCompOffOnAllDay;
  }

  close() {
    this.router.navigate(['/setting/compensatoryoffpolicies/']);
  }

  timeFormate(event: any, type: String) {
    if (type == 'FullDayDuration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.CompensatoryOff.CompOffFullDayHrObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.CompensatoryOff.CompOffFullDayHrObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    } else if (type == 'HalfDayDuration') {
      if (event.target.placeholder == 'HH') {
        event.target.value = this.CompensatoryOff.CompOffHalfDayHrObj.hour.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      } else if (event.target.placeholder == 'MM') {
        event.target.value = this.CompensatoryOff.CompOffHalfDayHrObj.minute.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
      }
    }
  }
}
